// category — or. Canonical bazaar category display names.
// The KEY is the canonical English filter key stored in the database; the
// VALUE is what users read. Never translate the keys — products are matched
// against them.

export default {
  catHandmadeCrafts: 'Kootuu Dogoggoraa',
  catFashion: 'Hanga Fasiin',
  catFoodBeverage: 'Nyaataa dhammuu',
  catBeautyHealth: 'Quramaa Fayyaa',
  catHomeLiving: 'Manaa fi Guyyaa',
  catSportsOutdoors: 'Taphaa fi Alalsaa',
  catBooksMedia: 'Kitaabii fi Mediaa',
  catServices: 'Tajaajila',
};